// extracted by mini-css-extract-plugin
export default {"option":"Key2RoamModal_option__oDA97","label":"Key2RoamModal_label__f-gj9","textarea":"Key2RoamModal_textarea__D4ckc"};